export default __webpack_public_path__ + "static/media/nl-ads.e8b97c6f.webp";